import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useFormatCurrency() {
  const { i18n } = useTranslation();

  const formatCurrency = useCallback(
    (value: string | null | undefined) => {
      if (!value) return null;
      const numericValue = Number.parseFloat(value.replace(/[^\d.-]/g, ''));
      if (Number.isNaN(numericValue)) return value;
      return new Intl.NumberFormat(i18n.language, {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(numericValue);
    },
    [i18n.language],
  );

  return { formatCurrency };
}
